import React, { useState, useEffect } from 'react'
import { findIndex, isEmpty } from 'lodash-es'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import SelectedExpert from '../../../../widgets/selectedExpert/SelectedExpert'
import { getSchemaAssignExpert } from '../../../../redux/actions/assignExpert'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ProjectBasicInfoSubProject from '../../../../widgets/projectBasicInfo/ProjectBasicInfoSubProject'
import ProjectBasicInfo from '../../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'

const mockData = {
  message: 'Successfully',
  success: true,
  model: {
    header: 'ขั้นที่ 1 เลือกผู้ทรงคุณวุฒิ',
    subHeader: 'ข้อเสนอโครงการ ไทยต่อต้านยาเสพติดหนึ่ง',
    forms: {
      projectInfo: {
        projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
        mainProject: {
          header: 'โครงการหลัก',
          projectId: null,
          versionCode: null,
          projectNameTitle: 'ชื่อโครงการ',
          projectName: 'เด็กฉลาด ขอทำข้อตกลงเพิ่มเติม 1',
          projectCodeTitle: 'รหัสโครงการ',
          projectCode: 'R06-0220',
          projectTypeTitle: 'ประเภทโครงการ',
          projectType: 'โครงการวิจัยและประเมินผล',
          ownerNameTitle: 'ผู้ยื่นข้อเสนอ',
          ownerName: 'คุณ วัลลภ บุญประเสริฐ',
          activityTypeTitle: 'ลักษณะกิจกรรม',
          activityTypeTitle2: '(ประเภทโครงการ)',
          activityType: 'โครงการวิจัยและประเมินผล',
        },
        subProject: {
          header: 'โครงการย่อย',
          projectId: null,
          versionCode: null,
          projectNameTitle: 'ชื่อโครงการ',
          projectName: 'เด็กฉลาด ขอทำข้อตกลงเพิ่มเติม ย่อย',
          projectCodeTitle: 'รหัสโครงการ',
          projectCode: 'R06-0220-A',
          projectTypeTitle: 'ประเภทโครงการ',
          projectType: 'โครงการวิจัยและประเมินผล',
          ownerNameTitle: 'ชื่อผู้เสนอ',
          ownerName: 'คุณ ทอม แบรนเนอร์',
          activityTypeTitle: 'ลักษณะกิจกรรม',
          activityTypeTitle2: '(ประเภทโครงการ)',
          activityType: 'โครงการวิจัยและประเมินผล',
        },
      },

      ReviewerSelectedList: {
        header: 'รายชื่อผู้ทรงคุณวุฒิ',
        buttonAddExpertLabel: 'เพิ่มผู้ทรงคุณวุฒิ',
        itemsList: [],
      },
      ReviewerAssignList: {
        header: 'รายชื่อผู้ทรงคุณวุฒิ',
        searchLabel: 'เงื่อนไขค้นหา',
        buttonSearchLabel: 'ค้นหา',
        buttonResetLabel: 'ล้างข้อมูล',
        itemsList: [
          {
            id: '0C00738B-5EB0-4389-A6BF-FE490512EFB1',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย ปิยะวัติ บุญหลง',
            status: 'ด้านวิจัยประเมินผล',
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 3',
            stars: '3209',
            year: 2563,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '192C1912-6325-4EE7-A9BC-69767404F7B4',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย เลิศเกียรติ วงศ์โพธิพันธ์',
            status: 'ด้านการจัดการ/กระบวนการ, ด้านวิจัยประเมินผล, นักจัดการข้อมูล/ฐานข้อมูล',
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 1',
            stars: '5322',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '22979CE4-4F4B-477D-A429-7F4D83BADB61',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย สิน สื่อสวน',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '3FDFF8B8-F88A-4995-9266-24677E627CE2',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย สุริยนต์ ธัญกิจจานุกิจ',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '4C8D9CCA-FB0E-4442-B6B5-0D07C3303CF2',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย สมพงษ์ จิตระดับ',
            status: 'นักจัดการข้อมูล/ฐานข้อมูล',
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '4CEE0671-3899-4E48-8D6F-5AF21DD05CA0',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย วณี ปิ่นประทีป',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '56E22DC6-B8F5-4FFD-829E-F054B28E45E4',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย สุวัฒน์ จริยาเลิศศักดิ์',
            status: 'นักบริหาร',
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '582234A0-B712-4917-9CAE-079D6E7B0A5C',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย ระพีพันธุ์ สริวัฒน์',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '63467EB5-9D9B-44E9-AC1F-A6C6CA724808',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย สุพจน์ แซ่เล้า',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '63953',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย วิทยา ชาติบัญชาชัย',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '72AC21CE-BFB5-4C2C-9309-1EFE7E355BC9',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย ปาริชาต สถาปิตานนท์',
            status: 'ด้านพิธีการ, ด้านสื่อสาร',
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '882B9B6F-0A0D-44DC-B3D2-90D599BA69F8',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย โกเมศร์ ทองบุญชู',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '915A6043-8A56-4D92-A642-C3A09A05E54F',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย ชาญวิทย์ วสันต์ธนารัตน์',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: '982AAB3B-07D3-4721-A84D-2D89A8AD81C1',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย สารี อ๋องสมหวัง',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: 'D26C5088-1273-4FAA-9672-34ABC6FB6AAC',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย ประพนธ์ ผาสุขยืด',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: 'DA40B277-42AD-4671-9900-4C0321C21C17',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย ชวนพิศ ชุ่มวัฒนะ',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: 'E028C980-7358-4ABA-8E0B-5D2ED4D283D6',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย วศิน เพิ่มทรัพย์',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: 'E8D9E2E6-D364-4740-874F-CBFFA48E0D27',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย สมหมาย จันจาด',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: 'F604DCF4-953E-4469-A7E7-224F75FC007A',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย สุจิตต์ ไตรพิทักษ์',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
          {
            id: 'F63D2112-3762-40AB-A959-88846A6CFB49',
            avartar: 'https://image.flaticon.com/icons/png/512/149/149071.png',
            name: 'นาย วีรสิทธิ์ สิทธิไตรย์',
            status: null,
            group: 'บัญชีแผน-บัญชีคณะกรรมการ คณะที่ 2',
            stars: '610',
            year: 2564,
            isSelected: false,
            isOnline: false,
          },
        ],
        expertiseData: [
          {
            label: 'ด้านการจัดการ/กระบวนการ',
            value: '2164D757-C12A-49A0-A7C2-0B89DBC1E5E1',
            role: null,
          },
          { label: 'ด้านวิชาการ', value: 'C3DE71EB-9F51-4F41-9C25-E88041DDCAAA', role: null },
          { label: 'ด้านสื่อสาร', value: '8311F73E-EF45-4A18-81CF-1EC75C3FF9C1', role: null },
          { label: 'ด้านพิธีการ', value: '4F1E1C9D-DE68-4E45-86B8-DF25256647F6', role: null },
          { label: 'ด้านสันทนาการ', value: 'D763BD4D-C1A8-46D8-86B4-D15084A9991C', role: null },
          { label: 'ด้านวิทยากร', value: '5375252A-49A8-4E6E-B91E-82F53C130202', role: null },
          { label: 'นักบริหาร', value: 'D77BB974-F032-4E2F-A007-6B8734DDEDE9', role: null },
          {
            label: 'นักจัดการข้อมูล/ฐานข้อมูล',
            value: '436078F4-C91F-495B-8FB9-CD0C359330AB',
            role: null,
          },
          {
            label: 'ด้านวิจัยประเมินผล',
            value: '1A066976-9481-4367-88A0-5D4A70F02C72',
            role: null,
          },
        ],
      },
    },
  },
}

export default function AssignExpertSub() {
  const SELECTED_EXPERT = 'selectedExpert'

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const _schema = await getSchemaAssignExpert(projectId)
      //console.log(JSON.stringify(_schema.model))

      setSchema(mockData.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  let _selectedExpert = []
  try {
    _selectedExpert = JSON.parse(sessionStorage.getItem(SELECTED_EXPERT)) || []
  } catch (e) {}

  const [selectedExpert, setSelectedExpert] = useState(_selectedExpert)

  useEffect(() => {
    if (!isEmpty(selectedExpert)) {
      sessionStorage.setItem(SELECTED_EXPERT, JSON.stringify(selectedExpert))
    }
  }, [selectedExpert])

  const handleOnClickSelectExpert = (value, checked, data) => {
    setSelectedExpert((state) => {
      const dataIndex = findIndex(state, { id: data.id })
      if (dataIndex !== -1) {
        let newData = [...state]
        if (checked) {
          newData[dataIndex].isSelected = true
        } else {
          newData[dataIndex].isSelected = false
        }
        return newData
      } else {
        return [
          ...state,
          {
            id: data.id,
            name: data.name,
            isOnline: data.isOnline,
            isSelected: checked,
          },
        ]
      }
    })
  }

  const handleOnClickOnlineExpert = (value, checked, data) => {
    setSelectedExpert((state) => {
      const dataIndex = findIndex(state, { id: data.id })
      if (dataIndex !== -1) {
        let newData = [...state]
        if (checked) {
          newData[dataIndex].isOnline = true
          newData[dataIndex].isSelected = true
        } else {
          newData[dataIndex].isOnline = false
        }
        return newData
      } else {
        return [
          ...state,
          {
            id: data.id,
            name: data.name,
            isOnline: checked,
            isSelected: checked,
          },
        ]
      }
    })
  }

  if (error) {
    return (
      <SidebarProposal isSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isSubProject>
      <ContentHeader header={schema.header + 'โครงการย่อย'} subHeader={schema.subHeader} />

      <ProjectBasicInfoSubProject schema={schema.forms.projectInfo} />
      <br />
      <SelectedExpert
        schema={schema.forms}
        selectedExpert={selectedExpert}
        onClickSelectExpert={handleOnClickSelectExpert}
        onClickOnlineExpert={handleOnClickOnlineExpert}
      />
      <br />
    </SidebarProposal>
  )
}
